import Seo from "@/components/Seo";
import { business } from "@/data/site";

const sections = [
  {
    h: "Overview",
    p: [
      "Future Roofing and Repair (\"we,\" \"us,\" or \"our\") respects your privacy. This Privacy Policy explains how we collect, use, and protect the information you provide when you visit our website or request our services.",
    ],
  },
  {
    h: "Information We Collect",
    p: [
      "When you submit a quote request or contact form, we may collect your name, phone number, email address, property address, details about your roofing needs, and any photos you choose to upload. We may also collect basic, non-identifying technical information through standard website analytics.",
    ],
  },
  {
    h: "How We Use Your Information",
    p: [
      "We use the information you provide to respond to your inquiry, prepare estimates, schedule inspections or work, communicate with you about your project, and provide our roofing services. We do not sell your personal information.",
    ],
  },
  {
    h: "Sharing of Information",
    p: [
      "We may share limited information with trusted parties as needed to provide our services — for example, with insurance companies when assisting with a claim at your request. We do not share your information for unrelated marketing purposes.",
    ],
  },
  {
    h: "Photo Uploads",
    p: [
      "Photos you upload through our forms are used to help us understand and estimate your roofing needs. They are stored securely and accessed only by our team.",
    ],
  },
  {
    h: "Data Security",
    p: [
      "We take reasonable steps to protect the information you share with us. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.",
    ],
  },
  {
    h: "Your Choices",
    p: [
      "You may contact us at any time to ask about, update, or request deletion of the information you have provided. To do so, call us at " +
        business.phone +
        " or email " +
        business.email +
        ".",
    ],
  },
  {
    h: "Contact Us",
    p: [
      "If you have any questions about this Privacy Policy, please contact Future Roofing and Repair at " +
        business.phone +
        " or " +
        business.email +
        ".",
    ],
  },
];

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy | Future Roofing and Repair"
        description="Privacy Policy for Future Roofing and Repair, a family-owned roofing company serving Bucks County, PA."
      />
      <LegalShell title="Privacy Policy" sections={sections} />
    </>
  );
}

export function LegalShell({ title, sections }) {
  return (
    <>
      <section className="bg-charcoal border-b border-charcoal/15">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16">
          <p className="font-accent uppercase tracking-[0.25em] text-sm text-gold mb-2">Legal</p>
          <h1 className="font-heading text-5xl sm:text-6xl uppercase text-cream leading-[0.9]">{title}</h1>
        </div>
      </section>
      <section className="bg-cream">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
          {sections.map((s) => (
            <div key={s.h} className="mb-8">
              <h2 className="font-heading text-2xl sm:text-3xl uppercase text-charcoal mb-3">{s.h}</h2>
              {s.p.map((para, i) => (
                <p key={i} className="text-charcoal/80 leading-relaxed mb-3">
                  {para}
                </p>
              ))}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
